export default __webpack_public_path__ + "static/media/note.4e82bc3a.svg";